import { useMutation } from 'react-apollo';
import gql from 'graphql-tag';
import throwErrorInDev from '../../helpers/throwErrorInDev';
export function useRangeFilter(args) {
    const [applyRangeFilterMutation] = useMutation(gql `
    mutation setRange {
      setRangeFilter(id: $id, value: $value) @client {
        isActive @client
      }
    }
  `);
    const [clearRangeFilterMutation] = useMutation(gql `
    mutation ClearRangeFilter($id: String!) {
      clearRangeFilter(id: $id) @client
    }
  `);
    function apply({ min, max }) {
        if (!min || !min)
            throwErrorInDev(true, 'You must provide a min and max to applyRangeFilter');
        return applyRangeFilterMutation({
            variables: {
                id: args.filter.id,
                value: [min, max]
            }
        });
    }
    function clear() {
        return clearRangeFilterMutation({
            variables: {
                id: args.filter.id
            }
        });
    }
    return { apply, clear };
}
//# sourceMappingURL=useRangeFilter.js.map